<template>
  <ModalSlideUp @close-modal="closeFunction">
    <div slot="body" id="modal-shareholder">
      <div class="clear-both"></div>
      <!-- <div
        v-if="showingArrow.left"
        class="circle-button text-center cursor-pointer translate-center-absolute left-float"
        @click="changeIndex('left')"
      >
        <div class="circle-button-inner">
          <i class="fas fa-angle-left"></i>
        </div>
      </div>-->
      <!-- <div
        v-if="showingArrow.right"
        class="circle-button text-center cursor-pointer translate-center-absolute right-float"
        @click="changeIndex('right')"
      >
        <div class="circle-button-inner">
          <i class="fas fa-angle-right"></i>
        </div>
      </div>-->
      <div class="row company">
        <div class="header-index">
          <div class="header-orange-circle margin-auto-center">
            <div class="header-index-elem translate-center-relative">{{shareholderShowIndex}}</div>
          </div>
        </div>
        <div class="header-name">{{shareholderDataToShow.name}}</div>
      </div>
      <div class="stock-body">
        <div class="col-30">
          <div class="title">มูลค่าหุ้น (ลบ.)</div>
          <div class="body">{{(shareholderDataToShow.value).toFixed(2)}}</div>
        </div>
        <div class="col-40 padding-left-10">
          <div class="title">จำนวนหุ้น</div>
          <div class="body">{{parseNumberFormat(shareholderDataToShow.amount) }}</div>
        </div>
        <div class="col-20 padding-left-10">
          <div class="title">%หุ้น</div>
          <div class="body">{{shareholderDataToShow.percentage }}</div>
        </div>
      </div>
      <div class="table-wrapper">
        <div class="other-header">สัดส่วนการถือหุ้นอื่นๆ</div>
        <div class="other-wrapper">
          <div class="other-table-header">
            <div class="col-stock">หุ้น</div>
            <div class="col-n-stock">จำนวนหุ้น</div>
            <div class="col-percent-stock">%หุ้น</div>
          </div>
          <div
            class="overflow-y-auto other-scroll-wrapper"
            :class="{'overflow-y-shadow':showOverflowShadow}"
            ref="otherScrollWrapper"
            @scroll="onScroll"
          >
            <div
              class="cursor-pointer user-select-none"
              ref="otherRowWrapper"
              @mousedown="onMousedown"
              @mouseup="onMouseup"
              @mousemove="onMousemove"
            >
              <div
                class="other-row"
                v-for="(stock,index) in shareholderDataToShow.other"
                :key="stock.stockName"
                :class="{'other-row-first':index===0}"
                @click="redirectFunction(stock.stockName)"
              >
                <div class="col-stock">{{stock.stockName}}</div>
                <div class="col-n-stock">{{parseNumberFormat(stock.amount) }}</div>
                <div class="col-percent-stock">{{ stock.percentage }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ModalSlideUp>
</template>

<script>
import ModalSlideUp from "../global/ModalSlideUp";

import _orderBy from "lodash/orderBy";

export default {
  name: "shareholder-modal",
  data() {
    return {
      shareholderIndex: this.initialShareholderIndex,
      isModal: true,

      // Mouse Event
      mouseDown: false,
      mousePositionY: null
    };
  },
  components: {
    ModalSlideUp
  },
  props: {
    // Props to receive
    // maxWidth ( type: Number, required: false, description: 'Width of Modal Container')
    // closeFunction ( type: Function, required: false, description: 'Function for closing modal')
    // wrapperClickClose ( type:Boolean, required: false, description: 'Check whether invoke Close function when wrapper has been clicked')
    // escPressClose ( type:Boolean, required: false, description: 'Check whether invoke Close function when ESC button has been pressed')
    // allShareholderData ( type:Array, required: true, description: 'Array of shareholder data')
    // shareholderIndex ( type:Number, required: true, description: 'Index of shareholder to be show')
    // stockPrice ( type:Number, required: true, description: 'Price of the stock need for calculating value of total stock')
    // dragCoefficient ( type: Number, required: 0.2, description: 'Coefficient for dragging speed (increase this number to speedup)')
    // redirectFunction ( type: Function, required: false, description: 'Function to invoke when user click on search result (this will pass the element from search result as argument)')

    maxWidth: {
      type: Number,
      default: 600
    },
    closeFunction: {
      type: Function,
      default: () => {}
    },
    wrapperClickClose: {
      type: Boolean,
      default: true
    },
    escPressClose: {
      type: Boolean,
      default: true
    },
    shareholderModal: {
      type: Boolean,
      default: false
    },
    allShareholderData: {
      type: Array,
      required: true,
      validator: arr => {
        // Check array length first
        let validateFlag = !(arr.length === 0);
        arr.forEach(elem => {
          if (
            !("name" in elem) ||
            !("amount" in elem) ||
            !("percentage" in elem)
          ) {
            validateFlag = false;
          }
        });
        return validateFlag;
      }
    },
    initialShareholderIndex: {
      type: Number,
      default: 0,
      required: true
    },
    stockPrice: {
      type: Number,
      required: true
    },
    dragCoefficient: {
      type: Number,
      default: 0.2
    },
    redirectFunction: {
      type: Function,
      default: () => {}
    }
  },
  mounted() {},
  computed: {
    shareholderDataToShow() {
      let result = this.allShareholderData[this.shareholderIndex];
      let divideFactor = 1000000;

      // Calculate stock value
      result.value = (this.stockPrice * result.amount) / divideFactor;

      // Reorder other stock position
      result.other = _orderBy(result.other, ["percentage"], ["desc"]);

      return result;
    },
    shareholderShowIndex() {
      return this.shareholderIndex + 1;
    },
    showingArrow() {
      // check that we need to render left and right arrow or not
      return {
        left: !(this.shareholderIndex === 0),
        right: !(this.shareholderIndex + 1 === this.allShareholderData.length)
      };
    },
    showOverflowShadow() {
      return this.shareholderDataToShow.other.length > 6;
    }
  },
  watch: {
    shareholderModal() {
      return this.shareholderModal;
    }
  },
  methods: {
    parseNumberFormat(num) {
      if (num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return "0";
    },
    // changeIndex(direction) {
    //   switch (direction) {
    //     case "left": {
    //       this.shareholderIndex = this.shareholderIndex - 1;
    //       break;
    //     }
    //     case "right": {
    //       this.shareholderIndex = this.shareholderIndex + 1;
    //       break;
    //     }
    //     default: {
    //       return;
    //     }
    //   }
    // },
    closeModal(bool) {
      if (bool) {
        this.shareholderModal = false;
      }
    },
    onScroll() {
      let otherScrollWrapper = this.$refs.otherScrollWrapper;
      let otherRowWrapper = this.$refs.otherRowWrapper;

      if (
        otherScrollWrapper &&
        otherScrollWrapper.scrollTop + 250 >= otherRowWrapper.clientHeight
      ) {
        this.$refs.otherScrollWrapper.classList.remove("overflow-y-shadow");
      } else {
        this.$refs.otherScrollWrapper.classList.add("overflow-y-shadow");
      }
    },
    onMousedown(e) {
      this.mousePositionY = e.clientY;
      this.mouseDown = true;
    },
    onMouseup() {
      this.mouseDown = false;
    },
    onMousemove(e) {
      if (this.mouseDown) {
        this.$refs.otherScrollWrapper.scrollTop =
          this.$refs.otherScrollWrapper.scrollTop +
          (this.mousePositionY - e.clientY) * this.dragCoefficient;
      }
    }
  }
};
</script>

<style lang='scss' scoped>
#modal-shareholder {
  padding: 0px 0px 20px;
  font-family: DBHeaventRez;
}
.padding-left-10 {
  padding-left: 10px;
}

.circle-button {
  // border-radius: 50%;
  // width: 45px;
  // height: 45px;
  // font-size: 20px;
  color: $medium-grey;
  // background-color: $very-light-grey;

  .circle-button-inner {
    transform: translateY(-55%);
    // background-color: $very-light-grey;
    // border-radius: 50%;
    width: 45px;
    height: 45px;
    font-size: 20px;
    position: relative;
    i {
      position: absolute;
      top: 30%;
      left: 38%;
    }
  }

  &.left-float {
    position: absolute;
    top: 60%;
    left: 0;
  }

  &.right-float {
    position: absolute;
    top: 60%;
    right: 0;
  }
}

.modal-wrapper {
  // padding: 60px 50px 50px 50px;
  font-family: DBHeaventRez;
  width: 100%;
  position: relative;
  .fa-time-icon {
    color: $medium-grey;
    display: none;
  }
  .company {
    // display: flex;
    // justify-content: center;
  }
  .other-header {
    color: $finno-orange;
    font-family: DBHeaventRez;
    font-size: 12px;
    font-weight: bold;
    font-weight: 600;
    padding: 0px 5px;
  }

  .row {
    .header-index {
      // width: 25%;
      // text-align: center;
      // display: inline-block;
      // vertical-align: middle;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .header-orange-circle {
        background-color: $color-orange-finno;
        color: $base-white;
        width: 42px;
        height: 42px;
        border-radius: 50%;
        text-align: center;
        margin: 0 auto;
        font-size: 20px;
        font-weight: bold;
        .header-index-elem {
          position: relative;
          // font-size: 18px;
          top: 10%;
          // top: 25%;
        }
      }
    }

    .header-name {
      // display: inline-block;
      // width: 75%;
      color: $color-normal-text;
      @extend %font-size-s;
      vertical-align: middle;
      line-height: 30px;
      margin-top: 10px;
      text-align: center;
      margin-left: 5px;
    }
  }

  .stock-body {
    margin-top: 20px;
    padding: 0px 30px;
    display: flex;
    justify-content: space-evenly;
    .title {
      font-size: 12px;
      color: $color-orange-finno;
    }

    .body {
      font-family: DBHeaventRez;
      color: $color-normal-text;
      font-weight: bold;
      font-size: 16px;
      margin-top: 5px;
    }
  }

  .table-wrapper {
    margin-top: 30px;
  }

  .other-wrapper {
    padding: 0px 5px;

    .other-scroll-wrapper {
      max-height: 250px;
      // background-color: aquamarine;
    }
    .overflow-y-auto {
      // overflow-y: auto;
    }
    .overflow-y-shadow {
      box-shadow: inset 0 -18px 10px -10px rgba(252, 252, 252, 0.56);
    }

    .other-table-header {
      font-family: DBHeaventRez;
      margin-top: 15px;
      padding: 0px 5px 7px 5px;
      border-bottom: 1px solid $finno-orange;
      color: $color-secondary-text;
      display: flex;
      justify-content: space-evenly;
      font-size: 14px;
      .col-stock {
        width: 30%;
        // color: $color-normal-text;
        // margin: 0 auto;
        padding-left: 8%;
        font-size: 12px;
      }
      .col-n-stock {
        width: 30%;
        // margin: 0 auto;
        padding-left: 5%;
      }
      .col-percent-stock {
        width: 30%;
        padding-left: 8%;
      }
    }
    .other-row {
      padding: 10px 5px;
      border-bottom: 1px solid $very-light-grey;
      font-size: 12px;
      display: flex;
      justify-content: space-evenly;
      color: $color-normal-text;
      &.other-row-first {
        border-top: 0px;
      }
      .col-stock {
        width: 30%;
        // margin: 0 auto;
        padding-left: 8%;
      }
      .col-n-stock {
        width: 30%;
        // margin: 0 auto;
        padding-left: 5%;
      }
      .col-percent-stock {
        width: 30%;
        padding-left: 8%;
      }
      &:hover {
        background-color: $highlight-grey;
      }
    }
  }
}
</style>
